module.exports = __webpack_public_path__ + "img/about-forex.b3dd8971.png";